import { useRoutes } from "react-router";

import { routesConfig } from "./routes/routes-configs";

const AppRouter = ({ userRole }: { userRole: string[] }) => {
  return useRoutes(routesConfig());
};

export default AppRouter;
